<app-headnav [user]="userName" (info)="onInfo($event)" [logOutFlag]="logOutFlag" (getLogo)="onSavedLogo($event)">
</app-headnav>
<!--div class="task-box" cdkDrag *ngIf="expanded" [style.right.px]="taskBoxRight">
	<div class="row" style="background-color: rgb(28 36 51);  border-radius: 3px; padding-top: 0.375rem;
    padding-right: 0.375rem;
    padding-bottom: 0.375rem;
    padding-left: 0.375rem;
	border-right: 1px solid white;
    border-top: 1px solid white;
    border-left: 1px solid white;"
	>
		<span>
			<a style="cursor: pointer; color: white;" (click)="expandcollapse();" title="Expand/Collapse">
				<i *ngIf="!expanded" style="margin-left: 5px;  margin-bottom: 2px; vertical-align: middle;" class="fas fa-chevron-right" size="lg"></i>
				<i *ngIf="expanded" style="margin-left: 5px; margin-bottom: 2px; vertical-align: middle" class="fas fa-chevron-down" size="lg"></i>
			</a>
		</span>

		<span *ngIf="!expanded" style="font-size: 16px; margin-left:10px; color: white;">News
				Alert</span>
		<span *ngIf="expanded" style="font-size: 16px; margin-left:32%; color: white;">News
				Alert</span>
	</div>
	<div *ngIf="expanded" class="row">

		<iframe width="800px" height="800px" src="https://www.erisinfo.com/ca/">

		</iframe>
	</div>
</div>

<div class="task-box" *ngIf="!expanded" style="position:absolute; top: 10px" [style.right.px]="taskBoxRight"> 
	<div class="row" style="background-color: rgb(28 36 51);  border-radius: 3px; padding-top: 0.375rem;
    padding-right: 0.375rem;
    padding-bottom: 0.375rem;
    padding-left: 0.375rem;">
		<span>
			<a style="cursor: pointer; color: white;" (click)="expandcollapse();" title="Expand/Collapse">
				<i *ngIf="!expanded" style="margin-left: 5px;  margin-bottom: 2px; vertical-align: middle;" class="fas fa-chevron-right" size="lg"></i>
				<i *ngIf="expanded" style="margin-left: 5px; margin-bottom: 2px; vertical-align: middle;" class="fas fa-chevron-down" size="lg"></i>
			</a>
		</span>

		<span *ngIf="!expanded" style="font-size: 16px; margin-left:10px; color: white;">News
				Alert</span>
		<span *ngIf="expanded" style="font-size: 16px; margin-left:32%; color: white;">News
				Alert</span>
	</div>
	<div *ngIf="expanded" class="row">

		<iframe width="800px" height="800px" src="https://www.erisinfo.com/ca/">

		</iframe>
	</div>
</div-->
<div *ngIf="!userId" class="studio">
  <div class="loading">
    <img src="assets/images/loader.gif" alt="spinner" width="64" height="64" />
    
  </div>
</div>
<div *ngIf="userId" class="studio">
<section class="content">
	<div class="sidenav flex-container" [style.width]="sideNavWidth">
		<a href="#" title="Dashboard">
		<!--span aria-hidden="true" data-icon="&#xe90a;" class="icon-dashboard" style="font-size:32px"></span-->
		<span aria-hidden="true" data-icon="&#xe90a;" class="icon-dashboard" style="font-size:32px">
		</span>
		<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Dashboard</span>

		</a>
		<!-- <a href="report" title="Report Writer" target=_blank><i class="far fa-edit"></i></a><i class="fas fa-tachometer-alt"></i> -->
		<a href="cover" title="Cover Page" target=_blank><i class="icon-Cover" style="font-size:32px"></i>
			<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Cover, Header & Footer</span>
		</a>
		<a href="template" title="Template" target=_blank><i class="icon-Template" style="font-size:32px"></i>
			<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Templates</span>

		</a>
		<a href="complete" title="Completed Reports" target=_blank  class="active">
			<i style="margin-left: 5px" class="far fa-list-alt"></i>
			<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Complete Reports</span>
		</a>
		<!--hr class="m-2" style="background:grey; z-index:9999999;"-->
		<a href="company" style="border-top: 1px solid #000000;" title="Company" target=_blank><i class="icon-property" style="font-size:32px"></i>
			<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Company Info</span>

		</a>
				
		<!--hr class="m-2" style="background:grey; z-index:9999999;"-->
		<a title="Libraries" href="resources" style="border-top: 1px solid #000000" target=_blank>
		<span aria-hidden="true" data-icon="&#xe90f;" class="icon-Libraries" style="font-size:32px; margin-left:5px"></span>
		<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Libraries</span>

		</a>
		<!--hr class="m-2" style="background:grey; z-index:9999999;"-->
		<a *ngIf="isErisStaff=='Y'" title="ERIS" href="erisonly" style="border-top: 1px solid #000000" target=_blank>
			<i  class="icon-eris" style="font-size: 32px;"></i>
			<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">ERIS Only</span>

			</a>

		<a  (click)="toggleSideBar()"> 

			<i *ngIf="!toggleSideBarVar" class="pi pi-chevron-right" style="font-size: 24px;"></i>
			<i  *ngIf="toggleSideBarVar"class="pi pi-chevron-left" style="font-size: 24px;"></i>

		</a>





		
	</div>


	<div class="">
		
								
	<div id="orderTable" class="tableView" >


		<div class="row" style="margin:35px">
			<!-- <div class="col-md-12">
	<div class="dateContainer">

		<div style="text-align: right; margin-top: 10px; font-size: 12px;">        

			<label style="color: white; float:left; margin-top:10px;">{{numReports}} Reports</label>
			<span style="float:left; margin-top:8px; margin-left: 20px">
			<span style="color:white">From Date: </span>
				<p-calendar style="width:100px" appendTo="body" [(ngModel)]="fromDate" dateFormat="dd-M-y" inputStyleClass="calendar"></p-calendar>
				<span style="color:white; margin-left:20px">To Date: </span>
				<p-calendar style="width:100px" appendTo="body" [(ngModel)]="toDate" dateFormat="dd-M-y" inputStyleClass="calendar"></p-calendar>
				<button class="btn btn-dark btn-sm ml-3" style="background-color: rgb(9 17 33); margin-bottom: 5px;" [style.background-color]="searchDateButtonColor" (click)="search()" (mouseover)="hoverDateSearchButton()" (mouseleave)="leaveDateSearchButton()">Search</button>
				<i id="spin1" class="fa fa-spinner fa-spin" style="font-size:24px;color:white;margin-left:10px; display:none"></i>
				
				<span > 
				<span style="color:white; margin-left:20px">Keyword: </span>
				<input type="text" pInputText size="50" placeholder="Search for All Reports	" [(ngModel)]="keyInput" style="width:180px; background-color:rgb(28 36 51)">
				<button class="btn btn-dark btn-sm ml-3" style="background-color: rgb(9 17 33); margin-bottom: 5px;" [style.background-color]="keywordSearchButtonColor"(click)="keySearch()" (mouseover)="hoverKeywordSearchButton()" (mouseleave)="leaveKeywordSearchButton()">Search</button>
				<i *ngIf="keySearchLoading" class="pi pi-spin pi-spinner" style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F;"></i>

				<i id="spin1" class="fa fa-spinner fa-spin" style="font-size:24px;color:white;margin-left:10px; display:none"></i>
				</span>

				<a href="javascript:void(0)" class="btn btn-outline-dark btn-sm ml-3" 
					style="color:white; margin-bottom: 5px;" title="Export to Excel" (click)="exportExcel()">
					Export to Excel
				</a>
			</span>
		</div>
	</div>
	</div> -->

</div>

<p-table #dt [value]="reports" [columns]="selectedColumns" [scrollable]="true" scrollHeight="70vh" scrollDirection="both" paginator="f" rows="500"
	selectionMode="single" autoLayout="true" rowHover="true" [rowsPerPageOptions]="[500, 300, 200]" (onFilter)="onFilter($event)">
	<ng-template pTemplate="caption">
		<div class="table-header">

			<!-- this search bar needs to come first in the html, otherwise it messes the table up on smaller displays: -->
			<span style="float: right;">
				<i class="pi pi-search" style="margin:4px 4px 0 0"></i>
				<input class="pt-1 pb-1 pl-2 pr-2" type="text" pInputText size="12" placeholder="Search This Page" 
					(input)="dt.filterGlobal($event.target.value, 'contains')"
					style="width:auto; background-color: rgb(28 36 51); border: 0px; font-size: 12px;">
			</span>

			<span style="font-size: 12px"> {{numReports}} Reports</span>
			<i *ngIf="loading" class="pi pi-spin pi-spinner" style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F;"></i>

			<span style="font-size: 12px; margin-left:20px">From Date: </span>
			<p-calendar appendTo="body" [(ngModel)]="fromDate" dateFormat="dd-M-y" inputStyleClass="calendar pt-1 pb-1 pl-2 pr-2"></p-calendar>
			<span style="font-size: 12px; margin-left:20px">To Date: </span>
			<p-calendar appendTo="body" [(ngModel)]="toDate" dateFormat="dd-M-y" inputStyleClass="calendar pt-1 pb-1 pl-2 pr-2"></p-calendar>
			<button class="btn btn-dark btn-sm pt-1 pb-1 pl-2 pr-2 ml-2" style="background-color: rgb(9 17 33); font-size: 12px" [style.background-color]="searchDateButtonColor"
				(click)="search()" (mouseover)="hoverDateSearchButton()" (mouseleave)="leaveDateSearchButton()">Search</button>
			<i id="spin1" class="fa fa-spinner fa-spin" style="font-size:24px;color:white;margin-left:10px; display:none"></i>
			
			<span style="font-size: 12px; margin-left:20px">Keyword: </span>
			<input class="pt-1 pb-1 pl-2 pr-2" type="text" pInputText size="50" placeholder="Search for All Reports	" [(ngModel)]="keyInput"
				style="width:180px; background-color:rgb(28 36 51); border: 0px; font-size: 12px;">
			<button class="btn btn-dark btn-sm pt-1 pb-1 pl-2 pr-2 ml-2" style="background-color: rgb(9 17 33); font-size: 12px" [style.background-color]="keywordSearchButtonColor"
				(click)="keySearch()" (mouseover)="hoverKeywordSearchButton()" (mouseleave)="leaveKeywordSearchButton()">Search</button>
			<i *ngIf="keySearchLoading" class="pi pi-spin pi-spinner" style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F;"></i>

			<a href="javascript:void(0)" class="btn btn-outline-dark btn-sm pt-1 pb-1 pl-2 pr-2 ml-4 mr-0" 
				title="Export to Excel" (click)="exportExcel()" style="font-size: 12px">
				<span style="font-size: 12px; color: white">Export to Excel</span>
			</a>
			<button href="javascript:void(0)" class="btn btn-dark btn-sm ml-0 " style="background-color: rgb(9 17 33);padding:3px 6px"
				(click)="proOpt.toggle($event)">
				<i class="fas fa-chevron-down"></i>
			</button>
			<p-overlayPanel #proOpt [appendTo]="'body'"
				[dismissable]="true" [showCloseIcon]="false">
				<ng-template pTemplate>
					<a href="javascript:void(0)" class="btn btn-outline-dark btn-sm pt-1 pb-1 pl-2 pr-2" (click)="exportExcel('Y');proOpt.hide() "> Export to Project Only Excel</a>
				</ng-template>
			</p-overlayPanel>
			<p-multiSelect styleClass="pt-1 pb-1 pl-2 pr-2 ml-4" [style]="{minWidth: '100px', maxWidth: '100px'}"
				[options]="selectedDisplayCols" [(ngModel)]="selectedColumns" optionLabel="header"
				placeholder="Choose Columns" selectedItemsLabel="{0} columns selected" (onChange)="$event?.originalEvent?.originalEvent?.stopPropagation();"></p-multiSelect>
			<button class="btn btn-dark btn-sm ml-1" style="background-color: rgb(9 17 33);"
				(click)="saveSelectedColumns();" title="Save as Default Columns Display">
				<i class="fa fa-save"></i></button>

		</div>
	</ng-template>

	<!--ng-template pTemplate="caption">
		<span style="color:white">From Date: </span>
		<p-calendar appendTo="body" [(ngModel)]="fromDate" dateFormat="dd-M-y" inputStyleClass="calendar"></p-calendar>
		<span style="color:white; margin-left:20px">To Date: </span>
		<p-calendar appendTo="body" [(ngModel)]="toDate" dateFormat="dd-M-y" inputStyleClass="calendar"></p-calendar>
		<button class="btn btn-dark btn-sm ml-3" style="background-color: rgb(9 17 33)" [style.background-color]="searchDateButtonColor" (click)="search()" (mouseover)="hoverDateSearchButton()" (mouseleave)="leaveDateSearchButton()">Search</button>
		<i id="spin1" class="fa fa-spinner fa-spin" style="font-size:24px;color:white;margin-left:10px; display:none"></i>
		<span style="float: right"> 
		<span style="color:white; margin-left:20px">Keyword: </span>
		<input type="text" pInputText size="50" placeholder="Keyword Search" [(ngModel)]="keyInput" style="width:160px; background-color:rgb(28 36 51); border: 0px">
		<button class="btn btn-dark btn-sm ml-3" style="background-color: rgb(9 17 33)" [style.background-color]="keywordSearchButtonColor"(click)="keySearch()" (mouseover)="hoverKeywordSearchButton()" (mouseleave)="leaveKeywordSearchButton()">Search</button>
		<i id="spin1" class="fa fa-spinner fa-spin" style="font-size:24px;color:white;margin-left:10px; display:none"></i>
		</span>
		<div style="text-align: right; margin-top: 10px;" class="ui-table-globalfilter-container">        
		

<label style="color:#C2D63F; float:left; margin-top:8px">{{reports.length}} Reports</label>
			<i class="fa fa-search" style="margin:4px 4px 0 60px"></i>
			<input type="text" pInputText size="50" placeholder="Global Filter" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:260px; background-color: rgb(28 36 51); border: 0px
			;">
		</div>
	</ng-template-->

				<ng-template pTemplate="header" let-columns>

					<!-- Header Column Content: -->
					<th *ngFor="let col of columns"
						[ngStyle]="{'width': col.width,
									'background-color': col.field==='REPORT_TITLE'? 'rgb(195,212,47)' : null,
									'color': col.field==='REPORT_TITLE'? 'black' : 'white'}"
						style="padding:1px; font-size:12px; border: 2px solid rgb(9 17 33);" 
						[pSortableColumn]="col.sortfield"> 
						{{col.header}}
						<p-sortIcon *ngIf="col.field !== 'GROUP_LABEL'" [field]="col.searchfield"></p-sortIcon>
					</th>

					<!-- Reports Tab Columns Search Bars: -->
					<tr>
						<th *ngFor="let col of columns;" style="padding:2px;border: 2px solid rgb(9 17 33); background-color: rgb(28 36 51)">
							<input *ngIf="col.field !== 'GROUP_LABEL'" pInputText type="text"
								(input)="dt.filter($event.target.value, col.searchfield, col.filterMatchMode)"
								style="margin:0 2px; font-size:12px; width:98%; background-color: rgb(9 17 33); border:0px">																												
						</th>
					</tr>
				</ng-template>

				<ng-template pTemplate="body"  let-rowData let-columns="columns">
					<tr style="font-size:12px;">
						<td style="padding: 1px; padding-left: 3px; border: 2px solid rgb(9 17 33); background-color: rgb(28 36 51)" *ngFor="let col of columns;" [ngStyle]="{'width': col.width}">
							<span *ngIf="!col.field2&&!col.field3&&col.field!='ORDER_NUM'&&col.field!='PROJECT_NUMBER'&&col.field!='GROUP_LABEL'&&col.field!='FULL_ADDRESS'&&col.field!='REPORT_GROUP'">
								{{rowData[col.field]}}
								<ng-container *ngIf="col.field=='STATUS'">
									<a class="float-md-right" style="cursor: pointer; font-size: 16px;"
										(click)="getStatus(rowData.REPORT_ID); op1.toggle($event);" title="Edit Status">
										<i class="pi pi-angle-down" style="margin: 5px; pointer-events:none; color: rgb(201 218 251)"></i>
									</a>
									<p-overlayPanel #op1 [appendTo]="'body'">
										<ng-template pTemplate>
											<ng-container *ngFor="let item of statusList">
											<a href="javascript:void(0)" style="font-size:.8em; color: #C2D63F;"
												(click)="op1.hide(); changeStatus(rowData,item.STATUS)">{{item.STATUS}}</a>
												<br>
											</ng-container>
										</ng-template>
									</p-overlayPanel>
								</ng-container>
							</span>
							<span *ngIf="rowData.size!=0 && !rowData.project && col.field==='REPORT_GROUP'">
								<ng-container>
									<div style="position:relative">
										<div style="max-width:calc(100% - 20px);" [title]="rowData?.REPORT_GROUP?.GROUP_NAME || ''">
											{{rowData?.REPORT_GROUP?.GROUP_NAME || ''}}
										</div>
									</div>
								</ng-container>
							</span>
							<span *ngIf="col.field==='ASSESSOR' || col.field==='REVIEWER'">
								{{rowData[col.field][0] ? rowData[col.field][0].FULL_NAME : ''}}
							</span>
							<span *ngIf="col.field==='ASSIGNED_USERS'">
								<div *ngIf="rowData[col.field].length>1" style="display: flex; align-items: center;">
									{{rowData[col.field][0] ? rowData[col.field][0].FULL_NAME : ''}}
									<a class="float-md-right" style="cursor: pointer; font-size: 16px;"
										(click)="assignedUsersop.toggle($event);"
										title="View Assigned Users">
										<i class="pi pi-angle-down" style="margin: 5px;"></i>
									</a>
								</div>
								<p-overlayPanel #assignedUsersop [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true">
									<ng-template pTemplate>
										<div style="padding:4px; height:400px; overflow:auto; width:400px">
											<ng-container *ngFor="let item of rowData[col.field];">
												<span *ngIf="item.FIRST_NAME!==undefined">{{item.FIRST_NAME}} </span>
												<span *ngIf="item.LAST_NAME!==undefined">{{item.LAST_NAME}} </span>
												<span *ngIf="item.USER_EMAIL!==undefined">({{item.USER_EMAIL}})</span>
												<br>
											</ng-container>
										</div>
									</ng-template>
								</p-overlayPanel>
							</span>
							<ng-container *ngIf="col.field=='PROJECT_NUMBER'">
								<span *ngIf="rowData.PRIVATE_FLAG == 'Y'" class="mr-1"
									[title]="rowData.PROJECT_NUMBER">
									<i class="erisIconColor fas fa-lock"></i>
								</span>
								<span>
									{{rowData[col.field]}}
								</span>
							</ng-container>
							<ng-container *ngIf="col.field=='FULL_ADDRESS'&&rowData.FULL_ADDRESS">
								<span >
									<a [title]="rowData.FULL_ADDRESS" class="link-light line-clamp"
										style="cursor:pointer; text-decoration: underline;"
										(click)="op.toggle($event);getCords(rowData)">
										<i class= "fas fa-map-marker-alt" style="float:right; margin:3px; color: rgb(201 218 251)"></i>
										{{rowData.FULL_ADDRESS}}
								
									</a>
									<p-overlayPanel #op [appendTo]="'body'" [dismissable]="true" (onHide)="onHide()"
										[style]="{width: '550px', height: '550px'}">
										<span style="color:rgb(195,212,47)">
											{{rowData.FULL_ADDRESS}}
											<a *ngIf="!noLocation" style="color: red; display: inline-block;">
												(Address not valid)
											</a><br>
											<span *ngIf="rowData.PARCEL_ID">
												Parcel ID: {{rowData.PARCEL_ID}}
											</span>
											
										</span>
										<!--<agm-map id="test" class="googleMap2" controlSize=24 [latitude]="rowData.LATITUDE"
											  [longitude]="rowData.LONGITUDE" [zoom]="zoomV" [disableDefaultUI]="false" [zoomControl]="false" [disableDoubleClickZoom]='true'>
											  <agm-marker *ngIf="noLocation" [latitude]="rowData.LATITUDE" 
											  [longitude]="rowData.LONGITUDE">
												<agm-info-window>
													<strong>{{rowData.FULL_ADDRESS}}</strong>
												</agm-info-window>

											</agm-marker>
										</agm-map>-->
										<div id="googleMap2" class="googleMap2"></div>
									</p-overlayPanel>
								</span>
							</ng-container>
							<ng-container *ngIf="!col.field2&&col.field=='ORDER_NUM'">
								<a class="erisGreen1" (click)="op.toggle($event);">{{rowData.ORDER_NUM}}</a>
								<p-overlayPanel #op [styleClass]="'fixedoverlay'"
									[appendTo]="'body'" [dismissable]="true">
									<ng-template pTemplate>
										<ng-container *ngFor="let item of rowData.ORDER_REPORTS">
											<a style="font-size:12px; color:rgb(195,212,47)"
												[href]="item.REPORT_URL"
												target=_blank>{{item.REPORT_NAME}}</a><br>
										</ng-container>
									</ng-template>
								</p-overlayPanel>
							</ng-container>
							<ng-container *ngIf="!col.field2&&col.field=='GROUP_LABEL'">

								<!-- Tools menu: -->
								<a *ngIf="rowData.CONSULTANT!='Y'" class="erisIconColor"
									style="cursor: pointer; "
									(click)="toolsOp.toggle($event);" title="Tools">
									Tools
									<i class="pi pi-angle-down" style="position:relative;top:2px;cursor:pointer;font-size:16px;margin-left:5px;"></i>
								</a>
								<a *ngIf="rowData.CONSULTANT=='Y'" class="erisIconColor"
									style="cursor: default; text-decoration:none; opacity:0.5; " title="Tools">
									Tools
								</a>
								<p-overlayPanel #toolsOp [appendTo]="'body'">
									<div>
										<a *ngIf="rowData.size!=0" title="Project Documents"  style="cursor:pointer;" class="m-1 erisIconColor"  data-toggle="modal" data-target="#fileModal" (click)='uploadType="FILE"; currentRowData=rowData; getAllBk(rowData.PROJECT_ID, rowData.REPORT_ID)'>
											<i class="fas fa-file-upload"></i>
											Project Documents
										</a>
									</div>

									<div>
										<a  title="Share Report by Email" *ngIf="rowData.REPORT_ID" style="cursor:pointer;" [ngClass]="{'disable':noPrint}" class="m-1 erisIconColor" (click)="resetEmailForm();showEmail(rowData.REPORT_ID)"> <!--op5.toggle($event);-->
											<i class="fas fa-envelope"></i>
											Share Report
										</a><i class="fas fa-info-circle erisIconColor" *ngIf='noPrint&&rowData.REPORT_ID&&rowData.REPORT_ID!=emailId' style="color:#F78181" title="Other report sharing in progress!"></i>										
										<div *ngIf="rowData.REPORT_ID==emailId">Email:
											<input class="rptInfo" type='text' [(ngModel)]="shareEmail" >
											<a  title="Send to Email" style="cursor:pointer;" class="m-1" (click)="shareByEmail(rowData.REPORT_ID);">
												<i *ngIf="!noPrint"  style="font-size:15px; pointer-events: none;"  class="erisIconColor fas fa-paper-plane"></i>														
											</a>
											<i *ngIf="noPrint" class="pi pi-spin pi-spinner" style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F;"></i>
										</div> 
									</div>
																			
									<p-overlayPanel #op5 [appendTo]="'body'"  [dismissable]="false"  [showCloseIcon]="true">
										<ng-template pTemplate> 
											Email: <br>
											<input class="rptInfo" type='text' [(ngModel)]="shareEmail"> 	
											<a  title="Send to Email" style="cursor:pointer;" class="m-1" (click)="shareByEmail(rowData.REPORT_ID);">

												<i *ngIf="!noPrint"   style="font-size:15px; color: rgb(201 218 251)"  class="fas fa-paper-plane"></i>
											</a>
											<i *ngIf="noPrint" class="pi pi-spin pi-spinner" style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F;"></i> 
										</ng-template> 
									</p-overlayPanel>

									<div>
										<a	(click)="op13.toggle($event);checkPM(rowData)"	title="Project Information"	style="cursor: pointer;" class="m-1 erisIconColor">
											<i class="fas fa-info-circle"></i>
											Project Information
										</a>
									</div>

									<!--a	(click)="op13.toggle($event);getProM()"	title="Project Manager"	style="cursor: pointer; text-decoration: underline;"><i	class="fas fa-user erisGreen"></i></a-->
									<div>
										<a *ngIf="rowData.REPORT_URL&&rowData.REPORT_URL.length>0" [href]="rowData.REPORT_URL" 
											style="margin-left:3px; color: rgb(201 218 251)" target=_blank class="m-1 erisIconColor">
											<i class="far fa-file-pdf"></i>
											PDF
										</a>
									</div>
									
									<p-overlayPanel #op13 [style]="{'width':'480px'}" [appendTo]="'body'">
										<ng-template pTemplate>
											<div class="row">
												<label style="margin-top:10px" class="col-md-6 inputLabel">Project Manager: </label>
													<!--select class="col-md-7 p-1 rptInfo" style="margin:4px; color: grey">
														<option></option>
														<option *ngFor="let item of pmList" [value]='item.USER_ID' [selected]="rowData.PROJECT_MANAGER[0]?.USER_ID==item.USER_ID">
															{{item.FULL_NAME + ', ' +'(' + item.USER_EMAIL + ')'}}
														</option>
													</select>
													<button class="btn btn-sm pt-0 pb-0 pl-1 pr-1"
														style="padding: 3px; font-size: 11px;"
														title="Update Project Manager" (click)="updatePM($event, rowData)"><i class="fas fa-check erisGreen" style="pointer-events:none"></i>
													</button-->
													<span style="margin-top:10px; color: #C2D63D" *ngIf="hasPM">	
													{{PMname}}
													</span>
											
												</div>	

												<div class="row">
												<label style="margin-top:10px" class="col-md-6 inputLabel">Client:</label>
												<span style="margin-top:10px; color: #C2D63D">	
													{{rowData.CLIENT_COMPANY_NAME}}
													</span>
												</div>

												<div class="row">
													<label style="margin-top:10px" class="col-md-6 inputLabel">Co-Client:</label>
													<span style="margin-top:10px; color: #C2D63D">	
													{{rowData.CO_CLIENT_COMPANY_NAME}}
													</span>
												</div>

												<div class="row">
													<label style="margin-top:10px" class="col-md-6 inputLabel">Consultant Company Name:</label>
													<span style="margin-top:10px; color: #C2D63D">	
														{{rowData.REPORT_COMPANY_NAME}}
														</span>
												</div>

												<div class="row">
													<label style="margin-top:10px" class="col-md-6 inputLabel">Report Received:</label>
													<span style="margin-top:10px; color: #C2D63D">	
														{{rowData.REPORT_RECEIVED_DATE}}
														</span>
												</div>
												
										</ng-template>
									</p-overlayPanel>
								</p-overlayPanel>
							</ng-container>
							<span *ngIf="col.field2&&col.field2=='TRANSACTION_TYPE'">
								{{rowData[col.field][0]?.TRANSACTION_TYPE}}<br>
								<ng-container *ngIf="col.field=='TRANSACTION_TYPE'">
								{{rowData.PROTOCOL[0]?.PROTOCOL}}
								</ng-container>
							</span>
							<span *ngIf="col.field3&&col.field3=='REPORT'">
								<a class="erisGreen1" [href]="'complete-rpt/'+rowData.PROJECT_ID+'/'+rowData.REPORT_ID" target=_blank>{{rowData[col.field]}}</a>	
								<!--a *ngIf="rowData.REPORT_URL&&rowData.REPORT_URL.length>0" [href]="rowData.REPORT_URL" class="float-md-right" target=_blank><i class="far fa-file-pdf"></i></a-->										
							</span>
							<span *ngIf="col.field3&&col.field3=='TEMPLATE'">
								<span *ngIf="rowData.TEMPLATE!=undefined&&rowData.TEMPLATE[0]!=undefined">
								<a class="erisIconColor" [href]="'template/'+rowData.TEMPLATE[0].TEMPLATE_ID" target=_blank>{{rowData[col.field][0].TEMPLATE_TITLE}}</a>		
							</span>								
							</span>
						</td>
					</tr>
					<input id="{{rowData.REPORT_ID}}" type="file" style="display: none;"  multiple (change)="uploadImage(rowData);"  accept='.png,.PNG,.jpg,.JPG, .jpeg,.JPEG'/>
					<input  id="{{rowData.REPORT_ID}}x"  type="file" style="display: none;" accept=".jpg,.png,.jpeg,.xlsx,.csv,.txt,.docx,.doc, .pdf" multiple (change)="uploadFile2(rowData)">

				</ng-template>
				</p-table>
			</div>
		<!--<div id="orderTable" class="tableView" >
		<p-table #dt styleClass="sticky-table"  [columns]="cols" [value]="reports" paginator="true" rows="500" selectionMode="single" autoLayout="true" rowHover="true" [rowsPerPageOptions]="[500, 300, 200]">
		<ng-template pTemplate="caption">
		<label style="color:#C2D63F; float:left; margin-top:8px">Total : {{userData.length}}</label>
			<div style="text-align: right" class="ui-table-globalfilter-container">        
				<i class="fa fa-search" style="margin:4px 4px 0 0"></i>
				<input type="text" pInputText size="50" placeholder="Global Filter" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
			</div>
		</ng-template>
		<ng-template pTemplate="header" let-columns>
			<tr  style="font-size:11px">
				<th *ngFor="let col of columns" [pSortableColumn]="col.field">
					{{col.header}}
					<p-sortIcon *ngIf="col.header!='Action'" [field]="col.field"></p-sortIcon>
					
				</th>
			</tr>        
		</ng-template>
		<ng-template pTemplate="body" let-rowData let-columns="columns">
			<tr style="font-size:11px" class="ui-selectable-row" [pSelectableRow]="rowData" >
				<td>
				
					<div *ngFor="let no of rowData.ORDER_NUM; trackBy: orderTrackBy; let k=index ">
						<a  style="color:rgb(195,212,47); cursor:pointer" target=_blank (click)="toViewer(rowData, k)">{{ rowData.ORDER_NUM[k] }}</a>
						<span style="font-weight:bold"
						*ngIf="rowData.BATCH_ID" [title]="'BATCH ID: '+rowData.BATCH_ID+', DESCRIPTION: '+rowData.BATCH_DESC">(B)</span>
					</div>
				</td>
				<td>
					{{rowData.SITE_NAME}}
				</td>
				<td>
					{{rowData.ADDRESS}}
				</td>
				<td>
					{{rowData.CITY}}
				</td>
				<td>
					{{rowData.COUNTY}}
				</td>
				<td>
					{{rowData.PROVSTATE}}
					<ng-container *ngIf="rowData.IS_ALERT">
						<button pButton type="button" icon="fas fa-info"  [ngClass]="{'ui-button-warning':rowData.IS_ALERT=='Y','ui-button-success':rowData.IS_ALERT=='N'}" style="margin-left:1px; padding:1px;width:16px; height:16px" title="Comments" data-target="#commentModal" data-toggle="modal" (click)='showComment(rowData.ORDER_NUM, rowData.COMMENTS, $event)'></button>
					</ng-container>				
				</td>
				<td>
					{{rowData.COMPANY_NAME}}
				</td>
				<td>{{ rowData.ORDER_USER }}
						</td>
				<td>
					{{rowData.PRIORITY}}
				</td>
				<td>
					{{rowData.DUE_DATE}}
				</td>
				<td>
					{{rowData.DATE_RECEIVED}}
				</td>
				<td>
					{{rowData.DATE_PROMOTED}}
				</td>
				<td>
					{{rowData.REPORT_DATE}}
				</td>
				<td>
					{{rowData.USER_FULL_NAME}}
				</td>
				<td class="link">
					
					<a *ngIf="rowData.REPORT_LINK" [href]="rowData.REPORT_LINK" style="color:rgb(195,212,47)" target='_blank' [title]="rowData.REPORT_LINK.substring(rowData.REPORT_LINK.indexOf('done')+5)">
						<span *ngIf="rowData.REPORT_LINK.indexOf('.pdf')>-1">PDF</span>
						<span *ngIf="rowData.REPORT_LINK.indexOf('.zip')>-1">TIFF</span>
						
					</a>
					<a *ngIf="rowData.WORD_REPORT_LINK.length>0" [href]="rowData.WORD_REPORT_LINK" style="color:rgb(195,212,47)" target=_blank [title]="rowData.WORD_REPORT_LINK.substring(rowData.WORD_REPORT_LINK.indexOf('AerialsDigital')+5)">
						WORD					
					</a>
					<a *ngIf="rowData.REPORT_ZIP_LINK.length>0" [href]="rowData.REPORT_ZIP_LINK" style="color:rgb(195,212,47)" target=_blank [title]="rowData.REPORT_ZIP_LINK.substring(rowData.REPORT_ZIP_LINK.indexOf('AerialsDigital')+15)">
						ZIP					
					</a>
				</td>
				<td>
					<span [title]="'GEOREFERENCING_COUNT:'+rowData.GEOREFERENCING_COUNT+',  ORDERED_COUNT:'+rowData.ORDERED_COUNT+',  RECEIVED_COUNT:'+rowData.RECEIVED_COUNT" style="color:rgb(195,212,47)">{{rowData.STATUS}}</span>
				</td>			
			</tr>
		</ng-template>
		<ng-template pTemplate="emptymessage" let-columns>
			<tr>
				<td [attr.colspan]="columns.length">
					No records found
				</td>
			</tr>
		</ng-template>
	</p-table>
			
						
						</div>-->
			
		<app-panel [header]="'Profile Management'" [opened]="showLogo" [align]="'right'" [fixed]="[-10, 54]"
			(didClosed)="showLogo = null">
			
			<ng-container name="body">
				
				<app-logo *ngIf="userInfo" class="w-100 h-100" [logoInfo]="logoInfo" [userInfo]='userInfo'
					(editReport)="onEditReport($event)" (logOut)='logOut()'></app-logo>
			</ng-container>
		</app-panel>
						
	</div>	


	</section>
	<div style="visibility:hidden">
		<app-pdfdata [content]='sharecontents' [appe]="shareappendices" [rptInfo]="sharereportInfo" [front]="sharefrontpages" [pop]='sharePOP'
		  [pdfgroup]="sharepdfs" [slot]="allRptSlots" [rdata]="r" [toPrint]="sharepdfType" [size]="sharelpagesize" (spinToggle)="pdfSpin($event)" (errorInfo)="showErrMsg($event)" (okmsg)="endPdf($event)"></app-pdfdata>
	  </div>	
</div>

<!-- FOOTER: -->
<app-footer></app-footer>

<div id="fileModal" #fileModal class="modal fade" data-backdrop='false'>
		<div class="modal-dialog modal-lg modal-dialog-centered ">
		<div class="modal-content" style="background:#444; color:#ccc">
			<!-- Modal Header -->
			  <!--<div class="modal-header">
			  <h6 id="" class="modal-title">Project Documents</h6>
			<a href='javascript:void(0)' class="btn btn-outline-success btn-sm  pr-1 pl-1 pt-0 pb-0 ml-3" title="Insert Image" (click)='insertImage()'><i class="fas fa-check"></i></a>
				<button type="button" class="close" data-dismiss="modal">&times;</button>
			</div>-->
			
			<!-- Modal body -->
			<div class="modal-body">
			<button type="button" class="close" data-dismiss="modal">&times;</button>
			
				
				<div style="width:100%">
		<ul class="nav nav-tabs">
		<li class="nav-item">
			<a class="nav-link" [ngClass]="{'active':uploadType=='FILE'}" data-toggle="tab" href="#files">Project Documents</a>		
		</li>
		<li class="nav-item" *ngIf="showPhotosTab">
		  <a class="nav-link" [ngClass]="{'active':uploadType=='PHOTO'}" data-toggle="tab" href="#photos">Photo Gallery</a>
		</li>
		<!-- remove Company Images:
		<li class="nav-item">
		  <a class="nav-link" [ngClass]="{'active':uploadType=='IMAGE'||uploadType=='BKIMAGE'||uploadType=='LOGO'}" data-toggle="tab" href="#images" >Company Images </a>
		</li>	 -->
	  </ul>
	  <!-- Tab panes -->
	  <div class="tab-content">
		
			<div id="files" class="container tab-pane" [ngClass]="{'active':uploadType=='FILE','fade':uploadType!='FILE'}" style="width:100%; padding:0; max-height:600px; overflow:auto">
				<div class="row" style="width:98%">
					<div *ngIf="uploadTotal!==0&&uploadTotal!==100&&uploadType=='FILE'" class="progress-wrapper col-md-10" style="height:10px;margin:4px">
						<div class="progress">
							<div class="progress-bar progress-bar-striped" style="height:10px;" [ngStyle]="{'width': uploadTotal + '%'}">
								{{uploadFiles}} of {{uploadNo}}
							</div>
						</div>
					</div>
					<a href='javascript:void(0)' class="btn uploadBtn ml-auto m-1" [ngClass]="{'disabled':uploadTotal!==0&&uploadTotal!==100}" (click)='upload("FILE")'>Upload</a>
					<span *ngIf="loading" class="fa fa-spinner fa-spin float-right" style="font-size:16px;color:rgb(195,212,47)"></span>
				</div>			
				<p-table #dt [value]="uploadedFiles" [columns]="cols2">
					<ng-template pTemplate="caption">
						<i class="pi pi-search"></i>
						<input type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Global Search" style="font-size:11px; padding:2px"/>
					</ng-template>
							<ng-template pTemplate="header"  let-columns>
								<tr>
									<th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width': col.width}" style="padding:1px; font-size:11px">
										{{col.header}} <p-sortIcon field="code"></p-sortIcon>               
									</th>
								</tr>
							</ng-template>
							<ng-template pTemplate="body" let-rowData let-columns="columns">
								<tr>
									<td *ngFor="let col of columns" [ngStyle]="{'width': col.width}" style="padding:1px; font-size:11px; text-overflow:ellipsis; overflow:hidden;">
										<span *ngIf="col.field=='FILE_NAME'"><a [href]="rowData.FILE_URL" style="color:rgb(195,212,47)" target=_blank>{{rowData[col.field]}}</a></span>
										<span *ngIf="col.field!=='FILE_NAME' && col.field!='PROJECT_ID'">{{rowData[col.field]}}</span>	
										<span *ngIf="col.field=='PROJECT_ID'">
											{{currentRowData.PROJECT_NUMBER}}
										</span>			
										<!-- remove delete button:												 -->
										<!-- <i  *ngIf="col.field=='FILE_NAME'" class="brn btn-outline-light btn-small far fa-trash-alt float-right mt-1"  style="color:#C2D63F"(click)="deleteFile(rowData, 'FILE')"></i> -->
										
									</td>																	
								</tr>
							</ng-template>
						</p-table>					
					</div>					
					<div id="images" class="container tab-pane" [ngClass]="{'active':uploadType=='IMAGE'||uploadType=='BKIMAGE'||uploadType=='LOGO', 'fade':uploadType!='IMAGE'&&uploadType!='BKIMAGE'&&uploadType!='LOGO'}">
						<div style="color:#C2D63F; font-size:.9em; padding-left:10px">
							<label class="radio-inline mr-2">
								<input type="radio" name="uploadimage" [checked]="imgGroup=='other'" (change)="imgGroup='other'"> 
								Images 
							</label> 
							<label class="radio-inline ml-3">
								<input type="radio" name="uploadimage" [checked]="imgGroup=='bk'" (change)="imgGroup='bk'">
								Background Images
							</label> 
							<label class="radio-inline ml-3"> 
								<input type="radio" name="uploadimage" [checked]="imgGroup=='logo'" (change)="imgGroup='logo'">
								Logos
							</label>
						</div>
					<div *ngIf="imgGroup=='other'"  style="padding:0; max-height:600px;  overflow-y: auto;overflow-x: hidden;">
					<div class="row" style="width:98%">
					<div *ngIf="uploadTotal!==0&&uploadTotal!==100&&uploadType=='IMAGE'&&imgGroup=='other'" class="progress-wrapper col-md-10" style="height:10px;margin:4px">
						<div class="progress">
							<div class="progress-bar progress-bar-striped" style="height:10px;" [ngStyle]="{'width': uploadTotal + '%'}">
								{{uploadFiles}} of {{uploadNo}}
							</div>
						</div>
					</div>
					<a href='javascript:void(0)' class="btn uploadBtn ml-auto m-1" [ngClass]="{'disabled':uploadTotal!==0&&uploadTotal!==100}" (click)='upload("IMAGE")'>Upload</a>
					<span *ngIf="loading" class="fa fa-spinner fa-spin float-right" style="font-size:16px;color:rgb(195,212,47)"></span>
				</div>				
						<!--<ng-container *ngFor="let other of others">
							<img class="bkImage" style="display:inline-block; width:100px; height:100px; margin:10px" [src]="other.FILE_TN_URL">
						</ng-container>-->
						<ul class="widget-item-list">
							<li class="item" *ngFor="let other of others">
								<div class="img-wrapper">
									<img *ngIf="other.FILE_TN_URL" [src]="other.FILE_TN_URL" class="img img-fluid"/>
								</div>
								<div *ngIf="other.FILE_DESCRIPTION.length>0" class="title" title="Click to Edit Description"  (click)="op41.toggle($event)">{{other.FILE_DESCRIPTION.substring(0, 40)}}<span *ngIf="other.FILE_DESCRIPTION.length>40"> . . . </span></div>
								<div *ngIf="other.FILE_DESCRIPTION.length==0" class="title" title="Click to Edit Description"  (click)="op41.toggle($event)" style="color:rgb(195,212,47);">Click to Edit File Description</div>
								<hr class="line">
								<a href="javascript:void(0);" class="remove" (click)="op41.toggle($event)"><i class="erisGreen far fa-edit" style="font-size: 10px;"></i></a>
								<!-- remove delete button: -->
								<!-- <a href="javascript:void(0);" class="remove" (click)="deleteFile(other, 'IMAGE')"><i class="erisGreen far fa-trash-alt" style="font-size: 10px;"></i></a> -->
								<p-overlayPanel #op41 [appendTo]="fileModal" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '300px'}">
									<ng-template pTemplate>
										<div style="margin: 0; color:#C2D63F;max-height:400px; overflow:auto; font-size:.9em"> 
											<strong>File Description : </strong><br> 
											<textarea class="col-md-12" rows=6 maxlength="100" style="font-size:11px; z-index:1010">{{other.FILE_DESCRIPTION}}</textarea>
											<button class="btn m-0 uploadBtn float-right" (click)="updateFile(other, 'IMAGE', $event)">Update</button>
										</div>
									</ng-template>
								</p-overlayPanel>
							</li>
					 
					  
						</ul>
					</div>
					
					<div *ngIf="imgGroup=='bk'"  style="padding:0; max-height:600px;  overflow-y: auto;overflow-x: hidden;">
					<div class="row" style="width:98%">
					<div *ngIf="uploadTotal!==0&&uploadTotal!==100&&uploadType=='BKIMAGE'&&imgGroup=='bk'" class="progress-wrapper col-md-10" style="height:10px;margin:4px">
						<div class="progress">
							<div class="progress-bar progress-bar-striped" style="height:10px;" [ngStyle]="{'width': uploadTotal + '%'}">
								{{uploadFiles}} of {{uploadNo}}
							</div>
						</div>
					</div>
					<a href='javascript:void(0)' class="btn uploadBtn ml-auto m-1" [ngClass]="{'disabled':uploadTotal!==0&&uploadTotal!==100}" (click)='upload("BKIMAGE")'>Upload</a>
					<span *ngIf="loading" class="fa fa-spinner fa-spin float-right" style="font-size:16px;color:rgb(195,212,47)"></span>
				</div>				
						<!--<ng-container *ngFor="let bk of bks">
							<img class="bkImage" style="display:inline-block; width:100px; height:100px; margin:10px" [src]="bk.FILE_TN_URL">
						</ng-container>-->
						<ul class="widget-item-list">
							<li class="item" *ngFor="let bk of bks">
								<div class="img-wrapper">
									<img *ngIf="bk.FILE_TN_URL" [src]="bk.FILE_TN_URL" class="img img-fluid"/>
								</div>
								<div *ngIf="bk.FILE_DESCRIPTION.length>0" class="title" title="Click to Edit Description"  (click)="op42.toggle($event)">{{bk.FILE_DESCRIPTION.substring(0, 40)}}<span *ngIf="bk.FILE_DESCRIPTION.length>40"> . . . </span></div>
								<div *ngIf="bk.FILE_DESCRIPTION.length==0" class="title" title="Click to Edit Description"  (click)="op42.toggle($event)" style="color:rgb(195,212,47);">Click to Edit File Description</div>
								<hr class="line">
								<a href="javascript:void(0);" class="remove" (click)="op42.toggle($event)"><i class="far fa-edit" style="font-size: 10px;"></i></a>
								<!-- remove delete button: -->
								<!-- <a href="javascript:void(0);" class="remove" (click)="deleteFile(bk, 'BKIMAGE')"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a> -->
								<p-overlayPanel #op42 [appendTo]="fileModal" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '300px'}">
									<ng-template pTemplate>
										<div style="margin: 0; color:#C2D63F;max-height:400px; overflow:auto; font-size:.9em"> 
											<strong>File Description : </strong><br> 
											<textarea class="col-md-12" rows=6 maxlength="100" style="font-size:11px; z-index:1010">{{bk.FILE_DESCRIPTION}}</textarea>
											<button class="btn m-0 uploadBtn float-right" (click)="updateFile(bk, 'BKIMAGE', $event)">Update</button>
										</div>
									</ng-template>
								</p-overlayPanel>
							</li>
					 
					  
						</ul>
					</div>
					
					<div *ngIf="imgGroup=='logo'"  style="padding:0; max-height:600px;  overflow-y: auto;overflow-x: hidden;">
						<div class="row" style="width:98%">
							<div *ngIf="uploadTotal!==0&&uploadTotal!==100&&uploadType=='LOGO'&&imgGroup=='logo'" class="progress-wrapper col-md-10" style="height:10px;margin:4px">
								<div class="progress">
									<div class="progress-bar progress-bar-striped" style="height:10px;" [ngStyle]="{'width': uploadTotal + '%'}">
										{{uploadFiles}} of {{uploadNo}}
									</div>
								</div>
							</div>
							<a href='javascript:void(0)' class="btn uploadBtn ml-auto m-1" [ngClass]="{'disabled':uploadTotal!==0&&uploadTotal!==100}" (click)='upload("LOGO")'>Upload</a>
							<span *ngIf="loading" class="fa fa-spinner fa-spin float-right" style="font-size:16px;color:rgb(195,212,47)"></span>
						</div>
				
						<!--<ng-container *ngFor="let logo of logos">
							<img class="bkImage" style="display:inline-block; width:100px; height:100px; margin:10px" [src]="logo.FILE_TN_URL">
						</ng-container>-->
						<ul class="widget-item-list">
							<li class="item" *ngFor="let logo of logos">
								<div class="img-wrapper">
									<img *ngIf="logo.FILE_TN_URL" [src]="logo.FILE_TN_URL" class="img img-fluid"/>
								</div>
								<div *ngIf="logo.FILE_DESCRIPTION.length>0" class="title" title="Click to Edit Description"  (click)="op43.toggle($event)">{{logo.FILE_DESCRIPTION.substring(0, 40)}}<span *ngIf="logo.FILE_DESCRIPTION.length>40"> . . . </span></div>
								<div *ngIf="logo.FILE_DESCRIPTION.length==0" class="title" title="Click to Edit Description"  (click)="op43.toggle($event)" style="color:rgb(195,212,47);">Click to Edit File Description</div>
								<hr class="line">
								<a href="javascript:void(0);" class="remove" (click)="op43.toggle($event)"><i class="far fa-edit" style="font-size: 10px;"></i></a>
								<!-- remove delete button: -->
								<!-- <a href="javascript:void(0);" class="remove" (click)="deleteFile(logo, 'LOGO')"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a> -->
								<p-overlayPanel #op43 [appendTo]="fileModal" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '300px'}">
									<ng-template pTemplate>
										<div style="margin: 0; color:#C2D63F;max-height:400px; overflow:auto; font-size:.9em"> 
											<strong>File Description : </strong><br> 
											<textarea class="col-md-12" rows=6 maxlength="100" style="font-size:11px; z-index:1010">{{logo.FILE_DESCRIPTION}}</textarea>
											<button class="btn m-0 uploadBtn float-right" (click)="updateFile(logo, 'LOGO', $event)">Update</button>
										</div>
									</ng-template>
								</p-overlayPanel>
							</li>
					 
					  
						</ul>
						</div>
					</div>
					<div id="photos" class="container tab-pane" [ngClass]="{'active':uploadType=='PHOTO','fade':uploadType!='PHOTO' }"  style="width:100%; padding:0; margin:0; max-height:600px; overflow-y: auto;overflow-x: hidden;">
						<div class="row" style="width:98%">
							<div *ngIf="uploadTotal!==0&&uploadTotal!==100&&uploadType=='PHOTO'" class="progress-wrapper col-md-10" style="height:10px;margin:4px">
								<div class="progress">
									<div class="progress-bar progress-bar-striped" style="height:10px;" [ngStyle]="{'width': uploadTotal + '%'}">
										{{uploadFiles}} of {{uploadNo}}
									</div>
								</div>
							</div>
							<a href='javascript:void(0)' class="btn uploadBtn ml-auto m-1" [ngClass]="{'disabled':(uploadTotal!==0&&uploadTotal!==100)||!showPhotosTab}" (click)='upload("PHOTO")'>Upload</a>
							<span *ngIf="loading" class="fa fa-spinner fa-spin float-right" style="font-size:16px;color:rgb(195,212,47)"></span>
						</div>
						<ul class="widget-item-list">
							<li class="item" *ngFor="let photo of photos">
								<div class="img-wrapper">
									<img *ngIf="photo.FILE_TN_URL" [src]="photo.FILE_TN_URL" class="img img-fluid"/>
								</div>
								<div *ngIf="photo.FILE_DESCRIPTION.length>0" class="title" title="Click to Edit Description"  (click)="op44.toggle($event)">{{photo.FILE_DESCRIPTION.substring(0, 40)}}<span *ngIf="photo.FILE_DESCRIPTION.length>40"> . . . </span></div>
								<div *ngIf="photo.FILE_DESCRIPTION.length==0" class="title" title="Click to Edit Description"  (click)="op44.toggle($event)" style="color:rgb(195,212,47);">Click to Edit File Description</div>
								<hr class="line">
								<a href="javascript:void(0);" class="remove" (click)="op44.toggle($event)"><i class="far fa-edit" style="font-size: 10px;"></i></a>
								<!-- remove delete button: -->
								<!-- <a href="javascript:void(0);" class="remove" (click)="deleteFile(photo, 'PHOTO')"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a> -->
								<p-overlayPanel #op44 [appendTo]="fileModal" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '300px'}">
									<ng-template pTemplate>
										<div style="margin: 0; color:#C2D63F;max-height:400px; overflow:auto; font-size:.9em"> 
											<strong>File Description : </strong><br> 
											<textarea class="col-md-12" rows=6 maxlength="100" style="font-size:11px; z-index:1010">{{photo.FILE_DESCRIPTION}}</textarea>
											<button class="btn m-0 uploadBtn float-right" (click)="updateFile(photo, 'PHOTO', $event)">Update</button>
										</div>
									</ng-template>
								</p-overlayPanel>	
							</li>
					 
					  
						</ul>
					</div>
			</div>
		
		</div>
		</div>
	</div>
	
		</div>	
</div>